import { render, staticRenderFns } from "./ApproveRebateAmount.vue?vue&type=template&id=2ed4f71c"
import script from "./ApproveRebateAmount.vue?vue&type=script&lang=js"
export * from "./ApproveRebateAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports